/* ============================================================
   Polka Tots — theme.js  (production, native Shopify AJAX)
   Overlay manager (delegated & self-healing), cart drawer,
   search sheet, mobile nav, quick view, carousels, wishlist,
   reveal-on-scroll, sticky header, scroll-top elephant.
   ============================================================ */
(function () {
  "use strict";

  var D = window.PTdata || { routes: {}, moneyFormat: "₹{{amount}}" };
  var PT = window.PT = {};

  /* ---------- tiny helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || document).querySelectorAll(s)); }

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    var fmt = format || D.moneyFormat || "₹{{amount}}";
    var value = (cents / 100.0);
    function grp(num, dec) {
      var n = num.toFixed(dec);
      var parts = n.split(".");
      var last3 = parts[0].slice(-3);
      var other = parts[0].slice(0, -3);
      if (other) last3 = "," + last3;
      other = other.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
      return other + last3 + (dec ? "." + parts[1] : "");
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case "amount": return grp(value, 2);
        case "amount_no_decimals": return grp(value, 0);
        case "amount_with_comma_separator": return value.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        case "amount_no_decimals_with_comma_separator": return grp(value, 0);
        default: return grp(value, 2);
      }
    });
  }
  PT.formatMoney = formatMoney;

  /* Bucks (the currency switcher) converts <span class=money> prices on page
     load and after cart requests. Prices a script draws later stay in rupees
     until it is asked to look again. */
  function reconvert() {
    try { if (window.bucksCC && typeof window.bucksCC.reConvert === "function") window.bucksCC.reConvert(); } catch (e) {}
  }
  PT.reconvert = reconvert;

  /* ---------- elephant (inline, reused for empty states) ---------- */
  var ELE = '<svg class="ele-inline" viewBox="0 0 120 100" fill="none" aria-hidden="true">' +
    '<path d="M18 84c-6-2-9-9-8-17 1-9 6-16 13-21 3-16 17-28 34-28 19 0 34 15 34 34 0 4-.6 8-1.8 11.6 3.4 2.2 5.8 6 5.8 10.4 0 4-3 7-6.6 7-2.4 0-4.5-1.3-5.6-3.2" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M40 84V70M62 84V70M82 84V72" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"/>' +
    '<path d="M23 46c-9-2-16 3-15 12 .6 6 5 9 9 8.5" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M40 30c-3-8-13-9-18-3-3 4-2 9 1 12" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<circle cx="74" cy="40" r="2.4" fill="currentColor"/>' +
    '<path d="M96 44c4 1 7 4 7 8" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"/></svg>';

  /* ---------- stars ---------- */
  var starSvg = '<svg class="ic" viewBox="0 0 24 24"><path d="M12 3l2.5 5 5.5.8-4 3.9 1 5.5L12 21l-4.9 2.6 1-5.5-4-3.9 5.5-.8L12 3z"/></svg>';
  $$("[data-stars]").forEach(function (el) { el.innerHTML = starSvg + starSvg + starSvg + starSvg + starSvg; });

  /* ---------- reveal ---------- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    $$(".r").forEach(function (el) { io.observe(el); });
  } else { $$(".r").forEach(function (el) { el.classList.add("in"); }); }

  /* ---------- sticky header shadow + scroll-top ---------- */
  var head = document.getElementById("head");
  var toTop = document.getElementById("ptTop");
  window.addEventListener("scroll", function () {
    var y = window.scrollY;
    if (head) head.classList.toggle("stuck", y > 10);
    if (toTop) toTop.classList.toggle("show", y > 700);
  }, { passive: true });

  /* ---------- toast ---------- */
  var TOAST_MS = 2000;
  var tt;
  function toast(m) {
    var toastEl = document.getElementById("toast"), toastMsg = document.getElementById("toastMsg");
    if (!toastEl) return;
    if (toastMsg) toastMsg.textContent = m;
    toastEl.classList.add("show");
    clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove("show"); }, TOAST_MS);
  }
  PT.toast = toast;

  /* ============================================================
     OVERLAY MANAGER — fully delegated + self-healing.
     Never assumes elements exist at load time; never leaves the
     page locked (scrim stuck / body overflow hidden = "freeze").
     ============================================================ */
  function lock() { document.documentElement.classList.add("no-scroll"); document.body.style.overflow = "hidden"; }
  function unlock() { document.documentElement.classList.remove("no-scroll"); document.body.style.overflow = ""; }

  function closeAll() {
    $$(".scrim.open, [data-cart-drawer].open, [data-search-sheet].open, [data-mnav].open, [data-qv].open, [data-filters].open, .coll-scrim.open")
      .forEach(function (el) { el.classList.remove("open"); });
    unlock();
  }
  PT.closeAll = closeAll;

  function openOverlay(sel) {
    var el = $(sel);
    if (!el) { return false; }
    $$(".scrim").forEach(function (s) { s.classList.add("open"); });
    el.classList.add("open");
    lock();
    return true;
  }
  function openCart() { if (openOverlay("[data-cart-drawer]")) {} else { window.location.href = (D.routes.cart || "/cart"); } }
  function openSearch() {
    if (openOverlay("[data-search-sheet]")) {
      var i = $("[data-search-sheet] input"); if (i) setTimeout(function () { i.focus(); }, 280);
    } else { window.location.href = "/search"; }
  }
  function openMnav() { openOverlay("[data-mnav]"); }
  PT.openCart = openCart;

  /* one delegated listener rules them all */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t.closest("[data-open-cart-btn]")) { e.preventDefault(); openCart(); return; }
    if (t.closest("[data-search-open]")) { e.preventDefault(); openSearch(); return; }
    if (t.closest("[data-mnav-open]")) { e.preventDefault(); openMnav(); return; }
    if (t.closest("[data-search-close],[data-mnav-close],.drawer__x,#drawerX,[data-close-overlays]")) { e.preventDefault(); closeAll(); return; }
    if (t.classList && (t.classList.contains("scrim") || t.classList.contains("coll-scrim"))) { closeAll(); return; }

    /* mobile-nav accordion */
    var accBtn = t.closest("[data-acc-btn]");
    if (accBtn) {
      var grp = accBtn.parentElement;
      var open = grp.classList.toggle("open");
      accBtn.setAttribute("aria-expanded", open ? "true" : "false");
      return;
    }

    /* collection filter drawer (mobile) */
    if (t.closest("[data-filter-toggle]")) {
      var f = $("[data-filters]"), s = $(".coll-scrim");
      if (f) f.classList.add("open"); if (s) s.classList.add("open"); lock();
      return;
    }
    if (t.closest("[data-filter-close]")) { closeAll(); return; }

    /* scroll to top elephant */
    if (t.closest("#ptTop")) { window.scrollTo({ top: 0, behavior: "smooth" }); return; }

    /* carousel arrows */
    var cPrev = t.closest("[data-crs-prev]"), cNext = t.closest("[data-crs-next]");
    if (cPrev || cNext) {
      var crs = (cPrev || cNext).closest("[data-carousel]");
      var track = crs && crs.querySelector("[data-crs-track]");
      if (track) {
        var card = track.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 22 : track.clientWidth * 0.8;
        track.scrollBy({ left: cPrev ? -step : step, behavior: "smooth" });
      }
      return;
    }
  });

  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
  /* bfcache / back-forward: never restore with a stuck overlay */
  window.addEventListener("pageshow", function () { closeAll(); });

  /* ---------- CART (native AJAX) ---------- */
  var minusSvg = '<svg class="ic" viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var plusSvg = '<svg class="ic" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';

  function renderCart(cart) {
    $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
    var body = $("[data-cart-body]");
    if (body) {
      if (!cart.item_count) {
        body.innerHTML = '<div class="empty"><span class="empty__ele">' + ELE + '</span><p>Your bag is empty.<br>Let\u2019s find something soft.</p><a class="btn btn--pri" href="/collections/all" data-close-overlays-after>Start exploring</a></div>';
      } else {
        body.innerHTML = cart.items.map(function (it) {
          return '<div class="li"><a href="' + it.url + '"><img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") : "") + '" alt="" width="66" height="88"></a>' +
            '<div class="li__b"><b>' + it.product_title + '</b><span>' + (it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : (it.product_type || "")) + '</span>' +
            '<div class="qty"><button data-cart-minus data-key="' + it.key + '" aria-label="Decrease">' + minusSvg + '</button><span>' + it.quantity + '</span><button data-cart-plus data-key="' + it.key + '" aria-label="Increase">' + plusSvg + '</button></div>' +
            '<div class="pr">' + formatMoney(it.final_line_price) + '</div></div>' +
            '<button class="li__rm" data-cart-remove data-key="' + it.key + '" aria-label="Remove"><svg class="ic" viewBox="0 0 24 24"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></button></div>';
        }).join("");
      }
    }
    $$("[data-cart-total]").forEach(function (el) { el.innerHTML = formatMoney(cart.total_price); });
    var bar = $("[data-ship-bar]");
    if (bar) {
      var thr = parseInt(bar.getAttribute("data-threshold"), 10) || 0;
      var pct = thr ? Math.min(100, Math.round(cart.total_price / thr * 100)) : 100;
      var msg = bar.querySelector("[data-ship-msg]"), fill = bar.querySelector("[data-ship-fill]");
      if (fill) fill.style.width = pct + "%";
      if (msg) {
        if (thr && cart.total_price < thr) msg.innerHTML = "You\u2019re <b>" + formatMoney(thr - cart.total_price) + "</b> away from free shipping";
        else msg.innerHTML = "\uD83C\uDF89 You\u2019ve unlocked <b>free shipping</b>!";
      }
    }
  }
  PT.renderCart = renderCart;

  function getCart() { return fetch((D.routes.cart || "/cart") + ".js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }); }

  function addToCart(id, qty) {
    return fetch((D.routes.cart_add || "/cart/add") + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || "Could not add"); throw res.data; }
        return getCart().then(function (c) { renderCart(c); return c; });
      });
  }
  PT.addToCart = addToCart;

  function changeCart(key, qty) {
    return fetch((D.routes.cart_change || "/cart/change") + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }

  document.addEventListener("click", function (e) {
    var minus = e.target.closest("[data-cart-minus]");
    var plus = e.target.closest("[data-cart-plus]");
    var rm = e.target.closest("[data-cart-remove]");
    if (minus || plus || rm) {
      var el = minus || plus || rm;
      var key = el.getAttribute("data-key");
      var span = el.parentElement ? el.parentElement.querySelector("span") : null;
      var cur = span ? parseInt(span.textContent, 10) : 1;
      var next = rm ? 0 : (plus ? cur + 1 : Math.max(0, cur - 1));
      changeCart(key, next);
      return;
    }
    var add = e.target.closest("[data-add-id]");
    if (add) {
      e.preventDefault();
      var id = add.getAttribute("data-add-id");
      if (!id) { toast("Select options first"); return; }
      add.classList.add("done");
      addToCart(id, 1).then(function () {
        /* The toast used to be suppressed here because it parked itself on the
           sticky add-to-bag bar. Its hidden state is fixed, so it can go back
           to being a 2s confirmation that auto-clears. */
        toast("Added to bag");
        openCart();
        setTimeout(function () { add.classList.remove("done"); }, 1200);
      }).catch(function () { add.classList.remove("done"); });
      return;
    }
    var w = e.target.closest("[data-wish]");
    if (w) { toggleWish(w); return; }
    var qvBtn = e.target.closest("[data-quickview]");
    if (qvBtn) { e.preventDefault(); openQuickView(qvBtn.getAttribute("data-quickview")); return; }
  });

  /* ---------- product form (PDP) AJAX — delegated ---------- */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-product-form]");
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var id = fd.get("id");
    var qty = parseInt(fd.get("quantity") || "1", 10);
    var btn = form.querySelector("[type=submit]");
    if (btn) btn.classList.add("done");
    addToCart(id, qty).then(function () {
      toast("Added to bag");
      openCart();
      if (btn) setTimeout(function () { btn.classList.remove("done"); }, 1400);
    }).catch(function () { if (btn) btn.classList.remove("done"); });
  });

  /* ---------- wishlist (localStorage) ---------- */
  function wishSet() { try { return JSON.parse(localStorage.getItem("pt_wish") || "[]"); } catch (e) { return []; } }
  function wishSave(a) { try { localStorage.setItem("pt_wish", JSON.stringify(a)); } catch (e) {} }
  function toggleWish(el) {
    var h = el.getAttribute("data-wish"); var a = wishSet(); var i = a.indexOf(h);
    if (i > -1) { a.splice(i, 1); el.classList.remove("on"); } else { a.push(h); el.classList.add("on"); }
    wishSave(a);
  }
  (function markWish() { var a = wishSet(); $$("[data-wish]").forEach(function (el) { if (a.indexOf(el.getAttribute("data-wish")) > -1) el.classList.add("on"); }); })();

  /* ---------- quick view ---------- */
  function closeQv() { var qv = $("[data-qv]"); if (qv) qv.classList.remove("open"); unlock(); }
  document.addEventListener("click", function (e) { if (e.target.closest("[data-qv-close]")) closeQv(); });

  function openQuickView(handle) {
    var qv = $("[data-qv]"), qvBody = $("[data-qv-body]");
    if (!qv || !qvBody) { window.location.href = "/products/" + handle; return; }
    qv.classList.add("open"); lock();
    qvBody.innerHTML = '<div class="qv__loading"><span class="qv__ele">' + ELE + '</span>Fetching something soft…</div>';
    fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (p) { qvBody.innerHTML = buildQuickView(p); wireQuickView(p, qvBody); reconvert(); })
      .catch(function () { window.location.href = "/products/" + handle; });
  }

  function buildQuickView(p) {
    var img = (p.featured_image || (p.media && p.media[0] && p.media[0].preview_image.src) || "");
    var opts = "";
    var hasVariants = p.variants.length > 1;
    if (hasVariants) {
      opts = '<div class="qv-opts">' + p.options.map(function (name, oi) {
        var vals = [];
        p.variants.forEach(function (v) { var val = v.options[oi]; if (vals.indexOf(val) < 0) vals.push(val); });
        return '<div class="qv-opt"><span class="qv-optlbl">' + name + '</span><div class="qv-optvals">' +
          vals.map(function (val, k) { return '<button type="button" class="size' + (k === 0 ? ' on' : '') + '" data-qv-opt="' + oi + '" data-val="' + val.replace(/"/g, "&quot;") + '">' + val + '</button>'; }).join("") +
          '</div></div>';
      }).join("") + '</div>';
    }
    var price = '<b>' + formatMoney(p.price) + '</b>' + (p.compare_at_price > p.price ? '<del>' + formatMoney(p.compare_at_price) + '</del>' : '');
    return '<div class="qv-grid">' +
      // The photo is contained, never cropped; a blur of it fills the rest of the frame.
      '<div class="qv-img"' + (img ? ' style="--pt-bd:url(&quot;' + img + (img.indexOf("?") > -1 ? "&amp;" : "?") + 'width=48&quot;)"' : '') + '><img src="' + img + '" alt="' + p.title + '" width="1080" height="1440"></div>' +
      '<div class="qv-info"><span class="pcard__type">' + (p.type || "") + '</span>' +
      '<h3 class="qv-title">' + p.title + '</h3>' +
      '<div class="qv-price">' + price + '</div>' +
      '<div class="qv-desc">' + (p.description || "").replace(/<[^>]+>/g, " ").slice(0, 200) + '…</div>' +
      opts +
      '<button class="atc" data-qv-add><svg class="ic" viewBox="0 0 24 24"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7V5.5a3 3 0 0 1 6 0V7"/></svg> Add to bag</button>' +
      '<a class="qv-full" href="/products/' + p.handle + '">View full details →</a>' +
      '</div></div>';
  }

  function wireQuickView(p, qvBody) {
    var chosen = p.options.map(function (_, oi) { var b = qvBody.querySelector('[data-qv-opt="' + oi + '"].on') || qvBody.querySelector('[data-qv-opt="' + oi + '"]'); return b ? b.getAttribute("data-val") : null; });
    $$("[data-qv-opt]", qvBody).forEach(function (b) {
      b.addEventListener("click", function () {
        var oi = +b.getAttribute("data-qv-opt");
        $$('[data-qv-opt="' + oi + '"]', qvBody).forEach(function (x) { x.classList.remove("on"); });
        b.classList.add("on"); chosen[oi] = b.getAttribute("data-val");
      });
    });
    var addBtn = qvBody.querySelector("[data-qv-add]");
    if (addBtn) addBtn.addEventListener("click", function () {
      var v = p.variants.find(function (vr) { return chosen.every(function (c, i) { return vr.options[i] === c; }); }) || p.variants[0];
      if (!v.available) { toast("That size is sold out"); return; }
      addToCart(v.id, 1).then(function () { closeQv(); openCart(); });
    });
  }

  /* ---------- newsletter ---------- */
  $$("[data-news-form]").forEach(function (form) {
    var btn = form.querySelector("[data-news-submit]"), input = form.querySelector("input[type=email]"), ok = form.querySelector("[data-news-ok]");
    if (btn && input && !form.getAttribute("action")) btn.addEventListener("click", function () { var v = input.value.trim(); if (v.indexOf("@") > 0) { if (ok) ok.style.display = "block"; input.value = ""; } });
  });

  /* ---------- cart PAGE (Section Rendering API) ---------- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-cart-qty]");
    if (!b) return;
    var section = b.closest("[data-cart-section]");
    if (!section) return;
    e.preventDefault();
    var sid = section.getAttribute("data-cart-section");
    var line = b.getAttribute("data-line");
    var to = parseInt(b.getAttribute("data-to"), 10);
    section.style.opacity = ".5";
    fetch((D.routes.cart_change || "/cart/change") + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: to, sections: sid, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state.sections && state.sections[sid]) {
        var tmp = document.createElement("div"); tmp.innerHTML = state.sections[sid];
        var fresh = tmp.querySelector("[data-cart-section]");
        if (fresh) section.replaceWith(fresh);
      } else { section.style.opacity = ""; }
      getCart().then(renderCart);
    }).catch(function () { section.style.opacity = ""; });
  });

  /* cart page note autosave */
  document.addEventListener("change", function (e) {
    var ta = e.target.closest("#cart-note");
    if (!ta) return;
    fetch((D.routes.cart || "/cart") + "/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ note: ta.value }) });
  });

  /* initial cart paint */
  getCart().then(renderCart).catch(function () {});
})();
